import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  configSettings: any = {
    enableNotifications: true,
    enableHttps: true,
    apiHost: 'egi-api.epiphanex.com',
    apiHostBg: 'egi-api-bg.epiphanex.com',
    socketHost: 'socket1.carbrewer.com:3002',
    apiHostCbr: 'api.carbrewer.com',
    apiHostHs: 'hs-api.epiphanex.com',
    restBaseUrl: '',
    authKey: '',
    apiKey: '',
    customerKey: 'c49a28b65315463f80538e8aca0b4635', //Edifice
    //customerKey: '33fdb1ad2d884b58a10ae5e1d8b6a0f7' //GrowPodium
    accountNum: '',
    currentSiteCode: 'dc1',
    token: '',
    refreshToken: '',
  };

  constructor() {
    this.configSettings = _.extend(
      {},
      this.configSettings,
      JSON.parse(localStorage.getItem('configSettings')),
    );
  }

  setObject = function (key: string, val: object) {
    localStorage.setItem(key, JSON.stringify(val));
  };
  set = function (configSettings: object) {
    this.configSettings = _.extend(this.configSettings, configSettings);
    this.setObject('configSettings', this.configSettings);
  };
  get = function () {
    return this.configSettings;
    //return JSON.parse(localStorage.getItem('configSettings'));
  };
  apiUrl = function () {
    const c = this.configSettings;
    return (c.enableHttps ? 'https://' : 'http://') + c.apiHost + c.restBaseUrl;
  };
}
